// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import CartDropdown from './CartDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'

// ** Third Party Components
import { Sun, Moon, LogOut } from 'react-feather'

// ** Reactstrap Imports
import { NavItem, NavLink } from 'reactstrap'
import { useDispatch } from 'react-redux'
import { handleLogout } from '../../../../redux/authentication'

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props

  const dispatch = useDispatch()
  const logOut = () => {
    dispatch(handleLogout())
    window.location.reload()
  }

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <ul className='nav navbar-nav align-items-center ms-auto'>
      {/* <IntlDropdown /> */}
      <NavItem className='d-none d-lg-block'>
        <NavLink className='nav-link-style'>
          <ThemeToggler />
        </NavLink>
      </NavItem>

      {/*   <NavbarSearch /> */}
      {/*   <CartDropdown /> */}
      {/* <NotificationDropdown /> */}
      <UserDropdown />

      <NavItem className='d-none d-lg-block'>
        <NavLink className='nav-link-style'>
          <LogOut
            className='ficon'
            style={{
              borderRadius: '50px',
              width: '25px',
              height: '25px'
            }}
            onClick={() => logOut()}
          />
        </NavLink>
      </NavItem>
    </ul>
  )
}
export default NavbarUser
